// extracted by mini-css-extract-plugin
export default {"alertBox":"screenModal_alertBox__mjNBT","modalContainer":"screenModal_modalContainer__8bZZ3","modal1":"screenModal_modal1__SbpOP","modal":"screenModal_modal__DBVnr"};